<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="项目名称:">
          <el-select v-model="listQuery.subject_id" clearable placeholder="请选择">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 折线图 -->
    <div class="chart" id="chart">

    </div>
    <div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column label="序号">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="ExamName" label="考试 ">
        </el-table-column>
        <el-table-column prop="ExamBeginTime"  label="考试时间">
        </el-table-column>
        <el-table-column prop="timeAvg" label="平均耗时">
        </el-table-column>
        <el-table-column prop="scoreAvg" label="平均成绩">
        </el-table-column>
        <el-table-column prop="studentQuantity" label="考试人数">
        </el-table-column>
        <el-table-column prop="qualifiedPass" label="合格率">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <i class="el-icon-search" @click="handleEdit(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>

    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                subjectList: [],
                avgdata: [],
                subjectStr: [],
                studentScoreStr: [],
                scoreAvgStr: [],
                subStr: [],
                listQuery: {
                    page: 1,
                    per_page: 20
                },
                tableData: []
            };
        },
        computed: {},
        created() {
        },
        mounted() {
            this.getData();
            window.addEventListener('resize', () => {
                this.$echarts.init(document.getElementById('chart')).resize()
            })

        },
        methods: {
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            // 获取全部的课程列表
            getData() {
                this.$http.subjectLine(this.listQuery)
                    .then(res => {
                        this.subjectList = res.data.subjectList;
                        this.tableData = res.data.data;
                        var timeStr = res.data.StrList.standardStr.split(",");
                        var passStr=res.data.StrList.qualifiedPass.split(",");
                        var passStr1 = [];
                        for(var i=0;i<passStr.length;i++){
                            passStr1.push(Number(passStr[i]));
                        }
                        this.getline(timeStr, passStr1)
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleEdit(scope) {
                if (scope.studentQuantity<1)
                {
                    this.$message.error('本次考试暂无有效数据！');
                    return false;
                }else
                {
                    this.$router.push({
                        name: 'subjectScoreDetail', query: {
                            subject_id: scope.subjectId,
                            exam_id: scope.ExamId,
                            sign: 'subjects',
                            subject: scope.subjectName
                        }
                    })
                }

            },
            //构建图标
            getline(timeStr, passStr) {
                let chart = this.$echarts.init(document.getElementById('chart'))
                // 绘制图表
                chart.setOption({
                    tooltip: {
                        trigger: "axis"
                    },
                    legend: {
                        orient: 'horizontal', // 'vertical'
                        x: 'right', // 'center' | 'left' | {number},
                        y: 0, // 'center' | 'bottom' | {number}
                        padding:40,
                        data: ["合格率"]
                    },
                    calculable: false,
                    xAxis: [{
                        type: "category",
                        boundaryGap: !1,
                        data: timeStr
                    }],
                    yAxis: [{
                        type: "value",
                        axisLabel: {
                            formatter: "{value} %"
                        }
                    }],
                    series: [{
                        name: "合格率",
                        type: "line",
                        data: passStr,
                        markPoint: {
                            data: [{
                                type: "min",
                                name: "最小值"
                            },
                                {
                                    type: "max",
                                    name: "最大值"
                                }]
                        }
                    }]
                });
            }
        },
    };
</script>

<style scoped lang="less">

  .chart {
    width: 100%;
    height: 300px;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/subjectLine.vue